import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=2fb15948"
import script from "./Thumbnail.vue?vue&type=script&lang=ts"
export * from "./Thumbnail.vue?vue&type=script&lang=ts"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=2fb15948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports